import React, { useEffect, useState } from "react";
import axios from "axios";
import { Env } from "../vite-env";
import {apiFetchComplete} from "../config.ts";
import { logDev } from "../utils/loggerHelpers.ts";

export const EnvironmentProvider = ({
  children,
}: {
  children: (env: Env) => React.ReactNode;
}) => {
  const [isEnvironmentLoaded, setIsEnvironmentLoaded] = useState(false);
  const [envData, setEnvData] = useState<Env | null>(null);

  useEffect(() => {
    const fetchEnvData = async () => {
      const response = await axios.get("/endpoints.json");
      const env = response.data as Env;
      env.URL_WEBAPP_API_PUBLIC = env.URL_WEBAPP_API;

      // In dev mode, route API requests through Vite proxy to avoid CORS issues
      if (import.meta.env.DEV) {
        if (env.URL_WEBAPP_API) env.URL_WEBAPP_API = '/dev-api';
        const origin = window.location.origin;
        if (env.URL_CALLING_SERVICE) env.URL_CALLING_SERVICE = `${origin}/dev-calling`;
        if (env.AXON_BASE_URL) env.AXON_BASE_URL = `${origin}/dev-axon`;
        if (env.SYNAPSE_BASE_URL) env.SYNAPSE_BASE_URL = `${origin}/dev-matrix`;
      }

      window.__ENV__ = env;
      setEnvData(window.__ENV__);
      setIsEnvironmentLoaded(true);
      logDev('Environment configuration loaded', {
        source: 'config',
        event: 'env_loaded',
        environment: import.meta.env.MODE,
        hasLogstash: !!(window.__ENV__?.LOGSTASH_URL || import.meta.env.VITE_LOGSTASH_URL)
      });
      apiFetchComplete(window.__ENV__.URL_WEBAPP_API);
    };

    fetchEnvData().catch(() => setIsEnvironmentLoaded(true));
  }, []);

  if (!isEnvironmentLoaded) {
    return null;
  }

  return envData && children(envData);
};
